import React, {Component} from 'react';

import PieChart from './PieChart.js';

import * as Constant from '@app/Constant.js';

import axios from '@app/lib/axios';



class AppPie extends Component {

    constructor(props) {
        super(props);
        var appMap = {};
        var ageMap = {};
        this.props.data.forEach(data => {
            var app = appMap[data.app_name];
            var age = ageMap[data.age];

            if(!app) app = 0;
            if(!age) age = 0;

            appMap[data.app_name] = ++app;
            ageMap[data.age] = ++age;
        }) ;

        var keys = Object.keys(appMap);
        var app = [];

        keys.forEach(key => {
            app.push({
                name : key,
                value : appMap[key]
            })
        });

        keys = Object.keys(ageMap);
        var age = [];

        keys.forEach(key => {
            age.push({
                name : key,
                value : ageMap[key]
            })
        });
        
        this.state = {
            app : app,
            age : age
        }
    }



	render() {
        
            return (
                <div className="card border-top border-3 border-info"  style={{height:this.props.height + "px"}}>
                    <div className="card-body">
                        <PieChart app={this.state.app} age={this.state.age}/>
                    </div>
                </div>
            )
           

	}

}


export default AppPie;